import apolloClient from './apolloClient';
import get from 'lodash/get';

// ⚠️ fetchPolicy: 'no-cache'
//
// Apollo Client’s caching can be surprising: by default every response is
// written to its in-memory store—even if you disable cache layers in the global
// config.  In our experience that leads to bloated memory footprints.

export async function makeGraphQLRequest(query, variables, dataFieldName) {
  const result = (await apolloClient.query({ query, variables, fetchPolicy: 'no-cache' })).data;

  return get(result, dataFieldName);
}

export async function makeGraphQLPaginatedRequest(query, variables, dataFieldName) {
  const result = (await apolloClient.query({ query, variables, fetchPolicy: 'no-cache' })).data;
  const data = get(result, dataFieldName);

  return { data: data.nodes, pageInfo: data.pageInfo };
}

export async function makeGraphQLAllPagesRequest(query, variables, dataFieldName) {
  let result = [];
  let nextToken = null;
  let hasNext = true;

  while (!!hasNext) {
    if (nextToken) {
      variables.paging = { first: 10, ...variables.paging, after: nextToken };
    }

    const response = await apolloClient.query({ query, variables, fetchPolicy: 'no-cache' });

    const data = get(response.data, dataFieldName);
    result = result.concat(data.nodes);
    nextToken = data.pageInfo.endCursor;
    hasNext = data.pageInfo.hasNextPage;
  }

  return result;
}
